var React = require('react');

function ItemisedSliderChevronInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("path",{"d":"M24,8 L24,14 L-8.001,14 L-8,46 L-14,46 L-14,8 L24,8 Z","id":"Combined-Shape","fill":"#F77429","transform":"translate(5.000000, 27.000000) rotate(135.000000) translate(-5.000000, -27.000000) "})));
}

ItemisedSliderChevronInline.defaultProps = {"width":"32px","height":"54px","viewBox":"0 0 32 54","version":"1.1"};

module.exports = ItemisedSliderChevronInline;

ItemisedSliderChevronInline.default = ItemisedSliderChevronInline;
